import * as React from 'react';
import classNames from 'classnames';
import * as styles from '../../styles/button.css';
import { ArrowL24, ArrowR24 } from '../../../icons';
export var ScrollButton = function ScrollButton(_ref) {
  var onClick = _ref.onClick,
      right = _ref.right;
  return /*#__PURE__*/React.createElement("button", {
    className: classNames(styles['button'], right ? styles['button-right'] : styles['button-left']),
    onClick: onClick,
    tabIndex: -1
  }, right ? /*#__PURE__*/React.createElement(ArrowR24, null) : /*#__PURE__*/React.createElement(ArrowL24, null));
};